import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { DateRecord } from "./DateRecord";
import { TimespanRecord } from "./TimespanRecord";

export const CalendarMarkerRecord = Record({
  id: null,
  label: null,
  // How is it displayed?
  icon: null,
  // Swatch color only -- for now
  color: null,
  drawOnTimeline: false,
  // When and where?
  startDate: DateRecord(),
  duration: TimespanRecord(),
  // Repeated?
  repeat: false,
  repeatFrequency: TimespanRecord(),
  repeatUntil: DateRecord()
});

const data = {
  objects: {
    startDate: "DateRecord",
    duration: "TimespanRecord",
    repeatFrequency: "TimespanRecord",
    repeatUntil: "DateRecord"
  }
};
createFromJS.registerCallback("CalendarMarkerRecord", createFromJS.createNestedCallback(CalendarMarkerRecord, data));
